import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/recommend-no-data.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-a839e9a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cnd-con" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["commond-no-data", { isWrongQuestion: _ctx.isWrongQuestion }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.isWrongQuestion)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "暂无错题，加入错题再来查看吧"))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, "暂未收藏题目，收藏之后再来查看吧~"))
    ])
  ], 2))
}